import { withFormik, Field } from 'formik';
import { get, trim } from 'lodash';
import { em } from 'polished';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import Yup from 'yup';

import {
  Button,
  CheckboxWrapper,
  ErrorMessage,
  Form,
  GridContainer,
  GridItem,
  TextFieldWrapper,
} from '../../common';
import { appTheme } from '../../../theme';

const TERMS_AND_CONDITIONS = 'hasAgreedToTerms';

const ButtonLink = styled.button`
  background-color: transparent;
  border: 0;
  border-radius: 0;
  color: ${appTheme.system.link};
  cursor: pointer;
  font: inherit;
  margin: 0;
  outline: none;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
  text-align: center;
  text-decoration: underline;
  user-select: none;
  vertical-align: middle;

  &::-moz-focus-inner {
    border-style: none;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: calc(${appTheme.spacing.default} * 2);
`;

const RegistrationButton = styled(Button)`
  display: block;
  margin: 0 auto;
  width: ${em('150px')};
`;

class EmailRegisterForm extends React.Component {
  handleFetchTerms = () => {
    this.props.fetchTerms();
  };

  render() {
    const { handleChange, handleSubmit, status, values } = this.props;

    return (
      <Form onSubmit={handleSubmit}>
        <GridContainer>
          <GridItem xs={12}>
            <Field
              className="text-field"
              component={TextFieldWrapper}
              id="firstName"
              label="First Name"
              name="firstName"
              onChange={handleChange}
            />
          </GridItem>
          <GridItem xs={12}>
            <Field
              className="text-field"
              component={TextFieldWrapper}
              id="lastName"
              label="Last Name"
              name="lastName"
              onChange={handleChange}
            />
          </GridItem>
          <GridItem xs={12}>
            <Field
              className="text-field"
              component={TextFieldWrapper}
              id="email"
              label="Email"
              name="email"
              onChange={handleChange}
            />
          </GridItem>
          <GridItem xs={12}>
            <Field
              className="text-field"
              component={TextFieldWrapper}
              id="password"
              label="Password"
              name="password"
              onChange={handleChange}
              type="password"
            />
          </GridItem>
        </GridContainer>
        {get(status, 'registerError') && (
          <ErrorMessage>{status.registerError}</ErrorMessage>
        )}
        <Field
          component={CheckboxWrapper}
          id={TERMS_AND_CONDITIONS}
          label={
            <span>
              {'I have read and agree to the '}
              <ButtonLink onClick={this.handleFetchTerms} type="button">
                Terms & Conditions
              </ButtonLink>
            </span>
          }
          name={TERMS_AND_CONDITIONS}
        />
        <ButtonWrapper>
          <RegistrationButton
            disabled={!values[TERMS_AND_CONDITIONS]}
            type="submit"
          >
            Sign Up
          </RegistrationButton>
        </ButtonWrapper>
      </Form>
    );
  }
}

EmailRegisterForm.propTypes = {
  errors: PropTypes.object.isRequired,
  fetchTerms: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,

  status: PropTypes.object,
};

export default withFormik({
  displayName: 'RegisterForm',
  handleSubmit: (values, { props, setStatus }) => {
    values.email = trim(values.email);
    return props
      .onRegister(values)
      .catch(error => setStatus({ registerError: error }));
  },

  mapPropsToValues: () => ({
    email: '',
    firstName: '',
    hasAgreedToTerms: false,
    lastName: '',
    password: '',
  }),
  validationSchema: Yup.object().shape({
    firstName: Yup.string().required('First name is required.'),
    lastName: Yup.string().required('Last name is required.'),
    email: Yup.string()
      .trim()
      .email('Please enter a valid email address.')
      .required('Email address is required.'),
    password: Yup.string().required('Password is required.'),
  }),
})(EmailRegisterForm);



// WEBPACK FOOTER //
// ./src/modules/RegistrationFormPage/components/EmailRegisterForm.js